import { render, staticRenderFns } from "./Title.form.vue?vue&type=template&id=48e01342&scoped=true&"
import script from "./Title.form.vue?vue&type=script&lang=js&"
export * from "./Title.form.vue?vue&type=script&lang=js&"
import style0 from "./Title.form.vue?vue&type=style&index=0&id=48e01342&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e01342",
  null
  
)

export default component.exports